export const fptiConstants = {
    SPACE_KEY: 'SKYGOV',
}

export const fptiEvents = {
    API_PERFORMANCE: 'API_PERFORMANCE',
}
